import "./Header.css";
import CTA from "./CTA";
// import passport from "../../assets/passport.jpg";
// import HeaderSocials from "./HeaderSocials";

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h1 className="text-light">Hello 👋🏿</h1>
        <h1>Ken Muyesu</h1>
        <h2 className="text-light">Full-Stack Developer</h2>
        <CTA />
        {/* <HeaderSocials /> */}

        {/* <div className="passport">
          <img src={passport} alt="passport-photo" />
        </div> */}

        {/* <a href="#contact" className="scroll__down">
          Scroll Down
        </a> */}
      </div>
    </header>
  );
};

export default Header;
